import { render, staticRenderFns } from "./reportees.vue?vue&type=template&id=2f35c686&scoped=true"
import script from "./reportees.vue?vue&type=script&lang=js"
export * from "./reportees.vue?vue&type=script&lang=js"
import style0 from "./reportees.vue?vue&type=style&index=0&id=2f35c686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f35c686",
  null
  
)

export default component.exports